/**
 * Sole owner of the "a logout is in flight" flag.
 *
 * Lives outside thunks/auth.js on purpose: services/auth.js and
 * graphql/authLinks.js both need to read it, and importing it from
 * thunks/auth.js would create a cycle (thunks/auth.js already imports
 * services/auth.js).
 *
 * Between deleteAllData() and logoutRedirect's navigation there is a window
 * where an in-flight operation can refresh the token against MSAL's cache
 * (left intact by preserveMsalCache) and write it back into the storage the
 * logout just cleared. This flag is what closes that race.
 *
 * @type {boolean}
 */
let logoutInFlight = false

/** @returns {boolean} Whether a logout is currently in flight. */
export const isLogoutInFlight = () => logoutInFlight

/** @returns {boolean} `false` if a logout was already in flight. */
export const beginLogout = () => {
  if (logoutInFlight) return false
  logoutInFlight = true
  return true
}

export const endLogout = () => {
  logoutInFlight = false
}
